import PropTypes from "prop-types"
import get from "lodash/get"
import parse from "html-react-parser"
import { stripMarkup } from "shared/lib/strip_markup"

import HintPill from "./hint_pill"

const ERROR_TRANSLATIONS = {
  "Default value can't be blank when the field is required and hidden": "Field cannot be blank",
}

export default function ErrorMessageForField({ field, errors, variant = "on-dark" }) {
  const untranslatedMessage = get(errors, field)
  const errorMessage = ERROR_TRANSLATIONS[untranslatedMessage] || untranslatedMessage

  if (!errorMessage || errorMessage.length === 0) {
    return null
  }

  const messages = Array.isArray(errorMessage) ? errorMessage : [errorMessage]

  return (
    <>
      {messages.map((msg, index) => (
        <HintPill key={index} tone="error" variant={variant}>
          {parse(stripMarkup(msg))}
        </HintPill>
      ))}
    </>
  )
}

ErrorMessageForField.propTypes = {
  field: PropTypes.string.isRequired,
  errors: PropTypes.object,
  variant: PropTypes.oneOf(["on-dark", "on-light", "on-black"]),
}
